export const promptKeys = [
  'example.prompt.requirements.list',
  'example.prompt.attachment.attachment',
  'example.prompt.compare,document',
  'example.prompt.find.document',
  'example.prompt.completed.training',
];
